import { buildReasonPage } from './reasonPageBuilder';
import { apportionmentInformationText as txt } from '../../definitions/constants';
import { CONVICTION_TYPE, FIELDS, YES_NO } from './helpers';

export default buildReasonPage({
  path: 'veteran-incarceration',
  title: txt.veteranIncarcerationPageTitle,
  description: txt.reasonPageSubDescription,
  trigger: {
    name: FIELDS.veteranIncarceratedOver60Days,
    title: txt.veteranIncarceratedOver60DaysTitle,
    labels: txt.veteranIncarcerationLabels,
    descriptions: txt.veteranIncarcerationDescriptions,
    tile: true,
    options: YES_NO,
    error: txt.veteranIncarceratedError,
  },
  conditionalFields: [
    {
      type: 'radio',
      name: FIELDS.veteranIncarcerationFelonyOrMisdemeanor,
      title: txt.convictionFelonyOrMisdemeanorTitle,
      labels: txt.convictionTypeLabels,
      options: CONVICTION_TYPE,
      error: txt.convictionTypeError,
    },
    {
      type: 'text',
      name: FIELDS.veteranIncarcerationFacilityName,
      title: txt.veteranIncarcerationFacilityNameTitle,
      maxLength: 150,
      error: txt.veteranIncarcerationFacilityNameError,
    },
    {
      type: 'text',
      name: FIELDS.veteranIncarcerationFacilityAddress,
      title: txt.facilityAddressTitle,
      maxLength: 500,
      error: txt.veteranIncarcerationFacilityAddressError,
    },
  ],
});
